'use client'

// BAO-125 Phase 5a: a signed-in browser advertising Global Privacy Control
// tells the server once per session, so the family's stored `ads_consent`
// flips to denied and `gpc_seen_at` is set even if the admin never touched the
// banner (webhooks and crons read stored columns only).
import { useEffect } from 'react'
import { detectGpc } from '@/lib/analytics/consent'

const SESSION_KEY = 'bh_gpc_reported'

export function GpcSignal() {
  useEffect(() => {
    if (typeof navigator === 'undefined' || !detectGpc(navigator)) return
    try {
      if (sessionStorage.getItem(SESSION_KEY) === '1') return
      sessionStorage.setItem(SESSION_KEY, '1')
    } catch {
      // sessionStorage unavailable: report every load, which is still correct
    }
    void fetch('/api/v1/analytics/consent', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ gpc: true }),
      keepalive: true,
    }).catch(() => {})
  }, [])
  return null
}
